import * as React from "react";

const Image = (props: any) => (
  <svg width={64} height={64} viewBox="0 0 64 64" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="none" d="M0 0h64v64H0z" fillOpacity={0} />
      <path fill="#7B838C" d="M12 12h40v40H12z" />
      <path
        fill="#FFF"
        d="M16 48h32v-7.333L38.727 32l-7.394 7.333-4-3.333L16 45.333z"
      />
    </g>
  </svg>
);

export default Image;

